<ng-container *ngIf="this.externalSettings == null">Loading...</ng-container>

<ng-container *ngIf="this.externalSettings != null">

    <div *ngIf="this.loggedIn | async" class="top-header-container">
        <div class="container top-header-contents">
            <a *ngIf="this.logo" class="navbar-brand cursor-pointer" (click)="this.onLogoClick()">
                <img [src]="this.src" width="240" alt="Logo" />
            </a>

            <span *ngIf="!this.environment.production" [ngStyle]="UIUtilityService.getHeaderStyle(this.externalSettings)">
                <button mat-button (click)="this.onInfoClick()">{{ this.getVersion() }} - {{ this.externalSettings.templates}} </button>
            </span>
            <div class="d-flex flex-row">
              <button  *ngIf="this.showQr" type="button" [ngStyle]="UIUtilityService.getHeaderStyle()" class="btn btn-white d-flex align-items-center me-2" routerLink="/qr-main">
                <mat-icon svgIcon="farQRCode"></mat-icon><span class="d-none d-md-inline-block font-header-login-control" [ngStyle]="UIUtilityService.getHeaderStyle()">&nbsp; {{
                  "LABEL_QRCODE" | translate }} &nbsp;</span>
              </button>

              <button type="button" [ngStyle]="UIUtilityService.getHeaderStyle()" class="btn btn-white d-flex align-items-center me-2" routerLink="/support-center">
                <mat-icon svgIcon="falInfoCircle"></mat-icon><span class="d-none d-md-inline-block font-header-login-control" [ngStyle]="UIUtilityService.getHeaderStyle()">&nbsp; {{
                  "LABEL_SUPPORT_CENTER" | translate }} &nbsp;</span>
              </button>

              <button (click)="logoff()" [ngStyle]="UIUtilityService.getBankButtonStyle()" class="font-header-login-signout" mat-button>
                {{ "SIGN_OUT_BTN" | translate }}
              </button>
            </div>
        </div>
    </div>

</ng-container>